import {observer} from 'mobx-react'
import {useEffect, useState} from 'react'
import {PaymentService} from 'rest'
import SubscriptionCard from './SubscriptionCard'
import ProductCard from './ProductCard'
import {Spinner} from 'components/template/Spinner'
import useUser from 'hooks/useUser'

export const List = observer(() => {
  const {user} = useUser()
  const [products, setProducts] = useState([])
  const [subscription, setSubscription] = useState<Record<string, any>>({})

  const [productsLoading, setProductsLoading] = useState(false)
  const [unsubscribing, setUnsubscribing] = useState(false)

  const localSubscription = user?.store?.stripe_subscription

  useEffect(() => {
    if (localSubscription) setSubscription(localSubscription)
  }, [localSubscription])

  const fetchData = async () => {
    try {
      setProductsLoading(true)
      const response = await PaymentService.getSubscriptionProducts()

      setProducts(response)
    } catch (error) {
    } finally {
      setProductsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const localTransaction = user?.coupon_center_txn

  const status = subscription?.status

  const changeSubscriptionStatus = async () => {
    try {
      if (status === 'canceled') {
        window.open(products[0]?.payment_link.url, '_blank')

        return
      }
      setUnsubscribing(true)
      const response = await PaymentService.postApiUnsubscribe({
        status: status,
      })

      setSubscription(response)
    } catch (error) {
    } finally {
      setUnsubscribing(false)
    }
  }
  return (
    <>
      {productsLoading && (
        <div className="w-4">
          <Spinner />
        </div>
      )}
      {localTransaction?.id && (
        <SubscriptionCard
          changeSubscriptionStatus={changeSubscriptionStatus}
          product={products[0]}
          unsubscribing={unsubscribing}
          subscription={subscription}
        />
      )}
      {!localTransaction?.id && <ProductCard plan={products[0]} />}
    </>
  )
})
